export default {"src":"/_next/static/media/generalCare.decb6a28.svg","height":34,"width":30,"blurWidth":0,"blurHeight":0};